export default __webpack_public_path__ + "static/media/courier-tracking-bike.df8280bf.svg";